import { Box, Typography } from '@mui/material';
import * as Preact from 'preact';
export var Component = function (p) {
    return (Preact.h(Box, { className: "unpublished", right: "0", bottom: "0", bgcolor: 'rgba(255,0,0,0.1)', height: "200px", width: "200px", padding: "10px", position: "absolute", zIndex: 10000 },
        Preact.h(Typography, { textAlign: "center", variant: "body3", color: "secondary" },
            "The following selected product(s) are UNPUBLISHED:",
            p.unpublishedProducts.map(function (product) {
                return Preact.h("p", null, product);
            }))));
};
